module.exports = __webpack_public_path__ + "distribution/img/mengban.d226fea9.png";